<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        currentTeamName: string;
    }>(),
    {
        currentTeamName: '',
    }
);

const teamName = computed(() => props.currentTeamName);
</script>

<template>
    <div class="flex">
        <span
            class="bg-blue-100 text-blue-800 text-xs font-bold font-medium m-2 px-3 py-1 border-round dark:bg-blue-900 dark:text-blue-300"
            >{{ teamName }}</span
        >
    </div>
</template>
